import { motion } from 'framer-motion';

const fadeIn = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 },
};

const sections = [
  {
    number: 1,
    title: 'Definiciones',
    content: [
      { label: 'Crosspay Solutions S.A.S.', text: 'Empresa colombiana que provee infraestructura tecnológica, conectividad transaccional, enrutamiento de pagos, servicios de orquestación de tesorería y acceso a aliados regulados.' },
      { label: 'Usuario', text: 'Persona natural o jurídica que utiliza los servicios tecnológicos de Crosspay.' },
      { label: 'Cuenta Habilitada', text: 'Credenciales que permiten el acceso a los servicios.' },
      { label: 'Aliados Regulados', text: 'Instituciones financieras, EMIs, PSPs, MSBs, procesadores y proveedores autorizados.' },
      { label: 'API', text: 'Interfaz tecnológica para integración.' },
    ],
  },
  {
    number: 2,
    title: 'Naturaleza del Servicio y Alcance Operativo',
    content: [
      { text: 'Crosspay actúa exclusivamente como proveedor de servicios tecnológicos. No recibe, custodia, gestiona ni tiene acceso a los fondos de los usuarios. Todas las operaciones monetarias son ejecutadas exclusivamente por entidades reguladas (Bancos, EMIs, PSPs, Transmisores de Dinero Autorizados, Procesadores Internacionales). Crosspay no está regulada como institución financiera por la Superintendencia Financiera de Colombia (SFC).' },
      { text: 'Los servicios incluyen: Conectividad transaccional, Enrutamiento seguro de pagos, Orquestación de tesorería, Infraestructura multi-rail para pay-ins/pay-outs, Soluciones de conciliación operativa.' },
    ],
  },
  {
    number: 3,
    title: 'Declaraciones y Obligaciones del Usuario',
    content: [
      { text: 'El Usuario declara que: su información es veraz, tiene capacidad legal, mantiene la confidencialidad de sus credenciales, no utilizará los servicios para actividades ilegales, sus fondos son de origen lícito, libera a Crosspay de responsabilidad frente a terceros y se compromete a informar sobre cambios corporativos.' },
    ],
  },
  {
    number: 4,
    title: 'Verificación de Identidad (KYC), Monitoreo y Cumplimiento (AML/CFT)',
    content: [
      { text: 'Crosspay realiza verificación de identidad incluyendo validación documental, revisión contra listas de sanciones (OFAC, ONU, UE, UK-HMT, Colombia), monitoreo continuo de transacciones y calificación de riesgo.' },
    ],
  },
  {
    number: 5,
    title: 'Cuenta de Usuario',
    content: [
      { text: 'Cada usuario podrá mantener una sola cuenta activa dentro de la plataforma.' },
    ],
  },
  {
    number: 6,
    title: 'Prestación de Servicios',
    content: [
      { text: 'Crosspay podrá limitar o suspender servicios con base en evaluaciones de riesgo y cumplimiento regulatorio.' },
    ],
  },
  {
    number: 7,
    title: 'Métodos de Pago',
    content: [
      { text: 'Todos los pagos se procesan a través de aliados regulados. Crosspay no maneja fondos directamente.' },
    ],
  },
  {
    number: 8,
    title: 'Inclusión de MTA para Transacciones en EE.UU.',
    content: [
      { text: 'Para transacciones con origen o destino en Estados Unidos, se incluirá un Agente de Transmisión de Dinero (MTA) autorizado como parte de la cadena operativa.' },
    ],
  },
  {
    number: 9,
    title: 'Límites Transaccionales',
    content: [
      { text: 'Los límites de transacción se establecen de acuerdo con el perfil de riesgo del usuario, los requisitos regulatorios aplicables y las políticas de los aliados regulados.' },
    ],
  },
  {
    number: 10,
    title: 'Cancelación, Suspensión y Bloqueo de Cuenta',
    content: [
      { text: 'Crosspay se reserva el derecho de cancelar, suspender o bloquear cuentas de usuario cuando existan indicios de incumplimiento de estos términos, actividades sospechosas o requerimientos regulatorios.' },
    ],
  },
  {
    number: 11,
    title: 'Jurisdicciones Restringidas',
    content: [
      { text: 'No se prestará servicio a jurisdicciones sancionadas ni a entidades incluidas en listas restrictivas internacionales.' },
    ],
  },
  {
    number: 12,
    title: 'API y Widgets',
    content: [
      { text: 'Queda prohibida cualquier modificación no autorizada de las APIs y widgets proporcionados por Crosspay.' },
    ],
  },
  {
    number: 13,
    title: 'Sitios Web Externos',
    content: [
      { text: 'Crosspay no asume responsabilidad por el contenido de sitios web externos enlazados desde su plataforma.' },
    ],
  },
  {
    number: 14,
    title: 'Ley Aplicable',
    content: [
      { text: 'Estos términos se rigen por las leyes de la República de Colombia.' },
    ],
  },
  {
    number: 15,
    title: 'Limitación de Responsabilidad',
    content: [
      { text: 'Crosspay no será responsable por daños indirectos, incidentales o consecuentes, ni por fallas atribuibles a terceros.' },
    ],
  },
  {
    number: 16,
    title: 'Modificaciones',
    content: [
      { text: 'Crosspay podrá actualizar estos términos en cualquier momento. Los cambios serán notificados a través de los canales oficiales.' },
    ],
  },
  {
    number: 17,
    title: 'Datos Personales',
    content: [
      { text: 'El tratamiento de datos personales se realiza en cumplimiento de la Ley 1581 de 2012 y demás normatividad aplicable en Colombia.' },
    ],
  },
  {
    number: 18,
    title: 'Propiedad Intelectual',
    content: [
      { text: 'Todo el contenido, diseño, marcas y tecnología del sitio web son propiedad exclusiva de Crosspay Solutions S.A.S.' },
    ],
  },
  {
    number: 19,
    title: 'Contacto',
    content: [
      { text: 'Para consultas legales o relacionadas con estos términos, puede escribirnos a: legal@crosspaysolutions.com' },
    ],
  },
];

export default function TermsPage() {
  return (
    <main id="main-content">
      {/* Hero */}
      <section className="pt-40 pb-20 text-center relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center_top,rgba(168,67,151,0.08),transparent_70%)] pointer-events-none" />
        <div className="mx-auto min-w-0 max-w-4xl px-4 sm:px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black font-headline tracking-tight">
              Términos y <span className="gradient-text">Condiciones</span>
            </h1>
            <p className="text-on-surface-variant text-lg mt-4 max-w-2xl mx-auto leading-relaxed">
              Términos y condiciones de uso del sitio web de Crosspay Solutions
            </p>
          </motion.div>
        </div>
      </section>

      {/* Intro */}
      <section className="pb-12 bg-transparent">
        <div className="mx-auto min-w-0 max-w-3xl px-4 sm:px-6">
          <motion.p {...fadeIn} className="text-on-surface-variant leading-relaxed">
            Este documento establece los términos y condiciones de uso bajo los cuales el USUARIO o
            CLIENTE podrá acceder a los servicios disponibles en el sitio web{' '}
            <a
              href="https://www.crosspaysolutions.com"
              target="_blank"
              rel="noopener noreferrer"
              className="gradient-text underline underline-offset-2"
            >
              www.crosspaysolutions.com
            </a>.
          </motion.p>
        </div>
      </section>

      {/* Sections */}
      <section className="pb-20 bg-transparent">
        <div className="mx-auto min-w-0 max-w-3xl px-4 sm:px-6 space-y-12">
          {sections.map((section, i) => (
            <motion.div
              key={section.number}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i < 4 ? i * 0.05 : 0 }}
            >
              <h2 className="text-2xl font-black font-headline mb-4">
                <span className="gradient-text">{section.number}.</span> {section.title}
              </h2>
              <div className="space-y-3">
                {section.content.map((item, j) => (
                  <p key={j} className="text-on-surface-variant leading-relaxed">
                    {item.label && <span className="font-semibold text-white">{item.label}: </span>}
                    {item.text}
                  </p>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </main>
  );
}
